import { flowNodeAudioOutput, flowNodePlaysVideo, type FlowNodeRow } from "@/types/flow"

export type FlowNodeLightboxMedia =
  | { kind: "image"; url: string; downloadUrl: string | null }
  | { kind: "video"; url: string; downloadUrl: string | null }

type LightboxNode = Pick<FlowNodeRow, "kind" | "content_type" | "media_url" | "download_url" | "chain_output_media">

/** Лайтбокс ноды. Превью без файла не открывается. */
export function flowNodeLightboxMedia(node: LightboxNode): FlowNodeLightboxMedia | null {
  if (flowNodePlaysVideo(node)) {
    const url = node.media_url
    if (!url) return null
    return { kind: "video", url, downloadUrl: node.download_url }
  }
  if (flowNodeAudioOutput(node)) return null
  const url = node.download_url || node.media_url
  if (!url) return null
  return { kind: "image", url, downloadUrl: node.download_url }
}
